exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-status-center[data-v-444b5fa8]{\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\n}\n#queueSelect[data-v-444b5fa8]{\r\n    width: 200px !important\n}\n.card[data-v-444b5fa8] {\r\n    max-width: 320px;\n}\n.cards-container[data-v-444b5fa8] {\r\n    display: flex;\r\n    min-width: 650px;\r\n    max-height: 650px;\r\n    flex-wrap: wrap;\r\n    justify-content: space-around;\n}\r\n\r\n", ""]);

// exports
